<template>
  <div>
    <q-dialog v-model="show" content-class="google-map-special">
      <div class="choose-google-map">
        <!-- tiptop -->
        <div class="tiptop" />

        <!-- 地图顶部返回 -->
        <div class="map-tiptop">
          <q-btn
            icon="app:backBIcon"
            flat
            round
            dense
            class="tiptop-pos"
            @click="onBack"
          />

          <span>{{ title }}</span>
        </div>

        <div class="map-body">
          <div class="map-box-inner">
            <!-- 地图 -->
            <div class="map-search">
              <div id="map" ref="map" />
              <!-- 搜索框 -->
              <div class="search-box">
                <q-icon name="app:googlemapSearch" class="search-icon" />
                <!-- m端 搜索输入框，新开页面搜素 -->
                <input
                  ref="searchInputTemp"
                  class="search-input-mob"
                  type="text"
                  :placeholder="$t('googlemap.findDeliveryAddress')"
                  @click="showSearch = true"
                />
              </div>
            </div>
            <!-- 地址 -->
            <div class="address-box">
              <!-- <q-icon name="app:googlemapPosition" class="icon" /> -->
              <span class="icon iconfont">&#xe614;</span>
              <div>{{ displayAddress }}</div>
            </div>

            <!-- 新增地址 -->
            <div v-if="pagestatus === 2">
              <!-- 输入地址， 当前状态如果是输入地址的话，就显示 -->
              <div class="address-address">
                <div :class="['option', 'bg-white', 'q-py-sm', 'maxlength']">
                  <span class="label">
                    {{ $t('googlemap.addressDetail') }}
                  </span>
                  <q-input
                    v-model="custom.detail"
                    class="inputBox"
                    placeholder="Eg: NO.22,Floor 3"
                    outlined
                    counter
                    maxlength="100"
                  />
                </div>

                <div :class="['option', 'bg-white', 'q-py-sm', 'maxlength']">
                  <span class="label"> {{ $t('googlemap.addressTag') }} </span>
                  <q-input
                    v-model="custom.label"
                    class="inputBox"
                    placeholder="Eg: home"
                    outlined
                    counter
                    maxlength="50"
                  />
                </div>
              </div>

              <!-- 底部按钮 -->
              <div class="footer-box pc-width-pull-full">
                <q-item
                  v-if="isLogin"
                  v-ripple
                  tag="label"
                  class="q-px-sm q-py-none footer-box-checkbox"
                >
                  <q-checkbox
                    v-model="custom.save"
                    :label="$t('googlemap.saveAddress')"
                  />
                </q-item>
                <q-btn
                  no-caps
                  unelevated
                  color="primary"
                  class="footer-button border-radius-8 text-weight-bolder font-size-16"
                  :label="$t('googlemap.useThisAddr')"
                  :loading="MLoading"
                  @click="onSave"
                />
              </div>
            </div>

            <!-- 历史页面 -->
            <div v-if="pagestatus === 1">
              <!-- 历史地址 -->
              <div v-if="historyList.length > 0" class="address-history">
                <strong>{{ $t('googlemap.historyAddr') }}</strong>

                <ul>
                  <li
                    v-for="(item, index) in historyList"
                    :key="index"
                    @click="chooseHistoryMap(item)"
                  >
                    <p>{{ item.address3 }}</p>
                    <p v-if="item.address1">
                      {{ item.address1 }}
                    </p>
                    <span v-if="item.address2">{{ item.address2 }}</span>
                  </li>
                </ul>
              </div>

              <!-- 底部按钮 -->
              <div class="footer-box pc-width-pull-full">
                <q-btn
                  :loading="MLoading"
                  no-caps
                  unelevated
                  color="primary"
                  class="footer-button border-radius-8 text-weight-bolder font-size-16"
                  :label="$t('googlemap.newAddrSet')"
                  @click="pagestatus = 2"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </q-dialog>

    <!-- 移动端搜索弹框 -->
    <q-dialog v-model="showSearch" maximized @show="onShowSearch">
      <div class="map-tiptop">
        <q-btn
          v-close-popup
          icon="app:backBIcon"
          flat
          round
          dense
          class="tiptop-pos"
        />
        <span>{{ $t('googlemap.changeAddr') }}</span>
      </div>
      <div class="search-box-mob">
        <div class="search-header">
          <div class="seach-mob">
            <!-- 文本搜索框 -->
            <input
              id="search-input-mo"
              ref="searchInputMo"
              v-model="searchContent"
              type="text"
              :placeholder="$t('googlemap.search')"
              class="seach-mob-input"
            />
            <q-icon name="app:googlemapSearch" class="search-icon" />
          </div>
          <div
            v-show="showSearchResult && String(searchContent)"
            class="search-result-panel"
          >
            <div
              v-show="autoCompleteList.length > 0"
              class="search-result-container"
            >
              <div
                v-for="item in autoCompleteList"
                :key="item.place_id"
                class="result-item"
                @click="onClickAddressItem(item.place_id)"
              >
                <p
                  class="result-item-desc"
                  v-html="highLightStr(searchContent, item.description)"
                />
              </div>
            </div>
            <div
              v-show="autoCompleteList.length === 0"
              class="search-result-container empty"
            >
              No Matched
            </div>
          </div>
        </div>
      </div>
    </q-dialog>

    <!--没保存返回提示-->
    <q-dialog v-model="nosaveback">
      <q-card
        class="checkDialog text-center full-width q-pt-md q-pb-sm border-radius-8"
      >
        <q-card-section>
          <q-icon name="r_error_outline" size="47px" color="negative" />
          <div class="text-weight-bolder font-size-16 q-pt-sm">
            <span>{{ $t('googlemap.exitConfirm') }}</span>
          </div>
          <div class="q-mt-lg">
            <q-btn
              no-caps
              unelevated
              color="primary"
              class="mb border-radius-8 text-weight-bolder"
              :label="$t('googlemap.goout')"
              @click="
                pagestatus = 1;
                nosaveback = false;
              "
            />
            <q-btn
              v-close-popup
              no-caps
              unelevated
              color="primary"
              class="mb border-radius-8 text-weight-bolder"
              :label="$t('googlemap.cancel')"
            />
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
    <!--地址check失败提示-->
    <q-dialog v-model="err.show">
      <q-card
        class="checkDialog text-center full-width q-pt-md q-pb-sm border-radius-8"
      >
        <q-card-section>
          <q-icon name="r_error_outline" size="47px" color="negative" />
          <div
            class="text-weight-bolder font-size-16 q-pt-sm"
            v-html="err.text"
          />
          <div class="q-mt-lg">
            <q-btn
              v-close-popup
              no-caps
              unelevated
              color="primary"
              class="mb border-radius-8 text-weight-bolder"
              :label="err.btnText"
              @click="show = true"
            />
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { debounce } from 'quasar';
import _ from 'lodash';
import { mapState } from 'vuex';
import { pushLog } from 'src/utils/pushLog';
import { loadingMixin } from '../pages/mixin/loadingMixin';
// eslint-disable-next-line object-curly-newline
import {
  loadGoogleMap,
  curPos,
  getSaveParam,
  notify,
  jakartaLocation,
} from './utils';
import {
  getGMAddressList,
  saveGMAddress,
  checkGMAddress,
} from '../api/googlemap';

export default {
  mixins: [loadingMixin],
  inject: {
    refreshShippingPrice: {
      from: 'refreshShippingPrice',
      default: null,
    },
  },
  data() {
    return {
      show: false, // 地图显示
      showSearch: false, // 搜索弹窗
      showSearchResult: false,
      searchContent: '',
      err: {
        show: false,
        text: '',
        btnText: '',
      }, // 检测失败弹窗
      // 地图实例S
      autoComplete: null,
      autoCompleteList: [],
      placeService: null,
      marker: null,
      map: null,
      geocoder: null,
      // 地图实例E
      pagestatus: 1, // 1=地址列表 2=新增地址
      nosaveback: false, // 未保存
      historyList: [], // 地图列表
      tempAddr: null, // 临时定位地址
      // 新增地址字段
      custom: {
        detail: '', // 详细地址
        label: '', // 地址标签
        save: true, // 是否保存为默认地址
      },
      isMounted: false,
    };
  },
  watch: {
    show(v) {
      if (v) {
        this.isMounted = false;
        this.init();
        this.getAddressList();
      }
    },
    searchContent(val) {
      if (!val) {
        return;
      }
      this.updateAutoComplete(val);
    },
  },
  // eslint-disable-next-line vue/order-in-components
  computed: {
    title() {
      const m = {
        1: this.$t('googlemap.changeAddr'),
        2: this.$t('googlemap.newAddrSet'),
      };
      return m[this.pagestatus];
    },
    // 临时推动地图中的地址文本
    displayAddress() {
      return this.tempAddr?.pacMsg || '';
    },
    ...mapState({
      localAddress: (state) => state.Menu.addressInfo,
      isLogin: (state) => !!state.Menu.userInfo?.id,
      hasNickName: (state) => state.Menu.userInfo?.nickName,
      user: (state) => state.Menu.userInfo,
    }),
    // 本地是否有地址
    hasLocalAddr() {
      const { latitude, longitude } = this.localAddress;
      return latitude && longitude;
    },
    isCheckoutPage() {
      return this.$route.name === 'checkout';
    },
  },
  mounted() {
    this.isMounted = true;
    // this.init(true);
    setTimeout(() => {
      this.mapSourceListenerAndInit();
    }, 600);
  },
  methods: {
    // 保存地址
    onSave() {
      const { lat, lng, saveParams } = this.tempAddr;
      const { phone } = this.user;
      const toName =
        saveParams.toName ||
        this.user.nickName ||
        this.$parent.getUser?.()?.nickName;
      const email =
        saveParams.email || this.user.email || this.$parent.getUser?.()?.email;
      if (!toName && this.isLogin) {
        this.err = {
          show: true,
          text: this.$t('googlemap.pleaseFitName'),
          btnText: this.$t('common.ok'),
        };
        return;
      }
      // 邮编不存在提示
      if (!saveParams?.postalCode) {
        this.err = {
          show: true,
          text: this.$t('googlemap.locationOutSide'),
          btnText: this.$t('common.ok'),
        };
        return;
      }
      const {
        detail: address1,
        label: address2,
        save: asDefault,
      } = this.custom;
      this.MSwitchLoading();
      this.checkAddr({ lat, lng })
        .then((ok) => {
          if (ok) {
            const address = {
              ...saveParams,
              asDefault,
              address1,
              address2,
              toName,
              phone,
              email,
            };
            // 没登录将地址存到本地
            if (!this.isLogin) {
              this.$store.dispatch('Menu/setAddressInfo', address);
              this.onClose();
              this.MSwitchLoading(false);
              return;
            }
            saveGMAddress({ address })
              .then((res = {}) => {
                const { code, data } = res;
                if (code === 200) {
                  const addr = data[0];
                  this.$store.dispatch('Menu/setAddressInfo', addr);
                  this.onClose();
                  this.getAddressList(false);
                  if (this.refreshShippingPrice) {
                    this.refreshShippingPrice();
                  }
                }
              })
              .finally(() => this.MSwitchLoading(false));
          } else {
            this.err = {
              show: true,
              text: this.$t('googlemap.locationOutSide'),
              btnText: this.$t('common.ok'),
            };
            this.MSwitchLoading(false);
          }
        })
        .catch(() => {
          this.MSwitchLoading(false);
        });
    },
    onBack() {
      const { pagestatus, isLogin } = this;
      if (!isLogin) return this.onClose();
      if (pagestatus === 1) {
        this.show = false;
      } else {
        this.nosaveback = true;
      }
    },
    onClose() {
      this.show = false;
      this.pagestatus = 1;
    },
    // 获取地址列表
    getAddressList(force = true) {
      const { isLogin, historyList } = this;
      if (!isLogin || (historyList.length && force)) return Promise.resolve();
      return getGMAddressList().then((res) => {
        this.historyList = res?.data || [];
      });
    },
    onShowSearch() {
      this.initSearch(this.$refs.searchInputMo);
    },
    // 请求当前地址符不符合配送范围
    checkAddr({ lat, lng }) {
      return new Promise((resolve, reject) => {
        checkGMAddress({ destination: `${lat},${lng}` })
          .then((res) => {
            if (res.code === 200) {
              resolve(true);
            } else {
              resolve(false);
              this.hide();
            }
          })
          .catch(() => {
            reject();
            this.hide();
          });
      });
    },
    // 从地址列表选择一个
    async chooseHistoryMap(item) {
      this.MSwitchLoading(true);
      this.checkAddr({
        lat: item.latitude,
        lng: item.longitude,
      })
        .then((ok) => {
          if (ok) {
            this.$store.dispatch('Menu/setAddressInfo', item);
            this.onClose();
            if (this.refreshShippingPrice) {
              this.refreshShippingPrice();
            }
          } else {
            this.err = {
              show: true,
              text: this.$t('googlemap.locationOutSide'),
              btnText: this.$t('common.ok'),
            };
          }
        })
        .finally(() => {
          this.MSwitchLoading(false);
        });
    },
    // (初始化操作)从地址列表中选择一个默认的地址/自身定位地址
    async chooseDefaultFromHistory() {
      const { localAddress, hasLocalAddr } = this;
      let checked = false;
      try {
        if (this.isCheckoutPage && !this.show) this.loading('map_init');
        if (hasLocalAddr) {
          const ok = await this.checkAddr({
            lng: localAddress.longitude,
            lat: localAddress.latitude,
          });
          checked = ok;
          if (!checked) {
            if (!this.refreshShippingPrice && this.isSupprotService) {
              this.err = {
                show: true,
                text: this.$t('googlemap.locationOutSide'),
                btnText: this.$t('googlemap.changeAddr'),
              };
            }
            return this.$emit('checkFaild');
          }
        }
        await this.getAddressList();
        const { historyList: his } = this;
        // 本地有地址并且check成功了
        if (checked) {
          const { longitude, latitude, address3 } = localAddress;
          const inHistory = his.find(
            (it) =>
              // eslint-disable-next-line implicit-arrow-linebreak
              it.address3 === address3 &&
              it.latitude === latitude &&
              it.longitude === longitude,
          );
          // 在用户历史列表中代表地址可用
          if (inHistory && this.refreshShippingPrice && this.isMounted) {
            return await this.refreshShippingPrice();
          }
          if (!inHistory) {
            return this.$emit('checkFaild');
          }
        }
        // 本地有地址就不用获取地址了
        if (hasLocalAddr) return;
        // 本地没地址就需要获取一个可用地址
        let defaultAddr = his.find((it) => it.asDefault) || his[0];
        if (!defaultAddr) {
          await this.getCurrentAddress();
          defaultAddr = { ...this.tempAddr.saveParams };
        }
        this.$store.dispatch('Menu/setAddressInfo', { ...defaultAddr });
        const ok = await this.checkAddr({
          lng: defaultAddr.longitude,
          lat: defaultAddr.latitude,
        });
        if (!ok) {
          if (!this.refreshShippingPrice) {
            this.err = {
              show: true,
              text: this.$t('googlemap.locationOutSide'),
              btnText: this.$t('googlemap.changeAddr'),
            };
          }
          return this.$emit('checkFaild');
        }
        if (this.refreshShippingPrice && this.isMounted) {
          await this.refreshShippingPrice();
        }
      } catch (error) {
        this.$emit('checkFaild');
      } finally {
        this.hide('map_init');
      }
    },
    // 初始化地址
    initAddress() {
      this.chooseDefaultFromHistory();
    },
    // 初始化地图相关 S
    initMap() {
      const maps = window.google?.maps;
      if (!maps) return;
      this.map = new maps.Map(this.$refs.map, {
        zoom: 15,
        mapTypeControl: false,
        zoomControl: true,
        disableDefaultUI: true,
        zoomControlOptions: {
          style: maps.ZoomControlStyle.LARGE,
        },
        mapTypeId: maps.MapTypeId.ROADMAP,
      });
      pushLog({
        key: 'dialog_map_inited',
        type: 'googlemap',
        url: this.$route.fullPath,
        env: process.env.NODE_ENV,
      });
      // 地图平移或缩放事件
      this.map.addListener('idle', () => {
        if (!this.map || !this.marker) return;
        // 获取地图边界
        const bounds = this.map.getBounds();
        if (!bounds) return;
        const ne = bounds.getNorthEast(); // LatLng of the north-east corner
        const sw = bounds.getSouthWest(); // LatLng of the south-west corder
        const lat1 = sw.lat();
        const lat2 = ne.lat();
        const lng1 = sw.lng();
        const lng2 = ne.lng();
        // 获取marker的经纬度
        const markB = this.marker.getPosition();
        if (!markB) return;
        const lat = markB.lat();
        const lng = markB.lng();
        const latIn = !!(lat > lat1 && lat < lat2);
        const lngIn = !!(lng > lng1 && lng < lng2);
        // 超出边界才会重现定位
        if (!latIn || !lngIn) {
          const curPosMiddle = this.map.getCenter();
          if (this.geocoder) {
            this.getAddressByGeocoder(curPosMiddle, {
              rePostion: true,
              isCenter: false,
            });
          }
        }
      });
      this.placeService = new window.google.maps.places.PlacesService(this.map);
    },
    initMark() {
      if (!window.google.maps) return;
      const locationMarker = {
        path: 'M5.12062 5.72065C11.6814 -0.840153 22.3186 -0.840154 28.8794 5.72065C35.4402 12.2815 35.4402 22.9186 28.8794 29.4794L17 41.3588L5.12062 29.4794C-1.44019 22.9186 -1.44019 12.2815 5.12062 5.72065ZM17 22.4001C19.651 22.4001 21.8 20.251 21.8 17.6C21.8 14.9491 19.651 12.8 17 12.8C14.349 12.8 12.2 14.9491 12.2 17.6C12.2 20.251 14.349 22.4001 17 22.4001Z',
        fillColor: '#10b981',
        fillOpacity: 1,
        strokeColor: '#10b981',
        strokeWeight: 0,
        rotation: 0,
        scale: 1,
      };
      this.marker = new window.google.maps.Marker({
        map: this.map,
        draggable: true,
        icon: locationMarker,
      });
      this.marker.addListener(
        'dragend',
        debounce((event) => {
          this.getAddressByGeocoder(event.latLng, {
            rePostion: false,
            isCenter: true,
            latlng: event.latLng,
          });
        }, 300),
      );
    },
    init(check = false) {
      if (!this.isDelivery) return;
      if (!this.isLogin) {
        this.pagestatus = 2;
      }
      this.$nextTick(async () => {
        await loadGoogleMap();
        const maps = window.google?.maps;
        if (!maps) return;
        this.geocoder = new maps.Geocoder();
        if (check || this.isCheckoutPage) {
          this.initAddress();
        }
        if (!this.$refs.map) return;
        this.initMap();
        this.initMark();
        this.setPoint();
      });
    },
    async initSearch(input, platform) {
      // if (!this.tempAddr) return;

      this.autocomplete = new window.google.maps.places.AutocompleteService();

      // this.autocomplete.addListener('place_changed', () => {
      //   const place = this.autocomplete.getPlace();
      //   this.pasrseAddress([place], 'OK');
      //   // 移动端在选择地址后需要关闭弹框
      //   this.showSearch = false;
      //   if (!place.geometry || !place.geometry.location) {
      //     return;
      //   }
      //   this.isMatch = this.setPinpointByResult(place, {
      //     rePostion: true,
      //     isCenter: true,
      //   });
      // });
      // this.autocompleteMo = autocomplete;
    },
    async getPlaceDetail(placeId) {
      return new Promise((resolved, rejected) => {
        try {
          this.placeService.getDetails({ placeId }, (place, status) => {
            if (
              status === window.google.maps.places.PlacesServiceStatus.OK &&
              place &&
              place.geometry &&
              place.geometry.location
            ) {
              resolved(place);
            } else {
              resolved(null);
            }
          });
        } catch (e) {
          resolved(null);
        }
      });
    },
    updateAutoComplete: debounce(function (searchContent) {
      const lat = this.tempAddr?.ipLocation?.lat() || jakartaLocation.lat;
      const lng = this.tempAddr?.ipLocation?.lng() || jakartaLocation.lng;
      const defaultBounds = {
        north: lat + 1,
        south: lat - 1,
        east: lng + 1,
        west: lng - 1,
      };
      const options = {
        input: searchContent.trim(),
        bounds: defaultBounds,
        fields: ['address_components', 'geometry', 'formatted_address', 'name'],
        strictBounds: false,
        // types: ['establishment'],
      };
      this.autocomplete
        .getPlacePredictions(options)
        .then((data) => {
          if (Array.isArray(data.predictions)) {
            this.autoCompleteList = [...data.predictions];
            this.showSearchResult = true;
          } else {
            this.autoCompleteList = [];
            this.showSearchResult = true;
          }
        })
        .catch((e) => {
          this.autoCompleteList = [];
          this.showSearchResult = false;
        });
    }, 1000),
    async onClickAddressItem($placeId) {
      if (!$placeId) return false;
      const place = await this.getPlaceDetail($placeId);
      if (!place) return false;
      console.log('place11', place);
      this.pasrseAddress([place], 'OK');
      // 移动端在选择地址后需要关闭弹框
      this.showSearch = false;
      this.searchContent = '';
      this.showSearchResult = false;
      this.autoCompleteList = [];
      if (!place.geometry || !place.geometry.location) {
        return;
      }
      this.isMatch = this.setPinpointByResult(place, {
        rePostion: true,
        isCenter: true,
      });
    },
    highLightStr(lightStr, targetStr) {
      if (!lightStr || !targetStr) {
        return '';
      }
      targetStr = String(targetStr);
      const reg = new RegExp(lightStr, 'gi');
      console.log('lightStr, targetStr', lightStr, targetStr);
      const resString = targetStr.replace(
        reg,
        (txt) => `<span style='color:#000;font-size: 18px;'>${txt}</span>`,
      );
      return resString;
    },
    // 初始化地图相关 E
    // 根据经纬度获取用户详细信息, 根据geocoder返回的结果拿到list，并处理 S
    getAddressByGeocoder(location, options) {
      this.geocoder.geocode({ location }, (results, status) => {
        this.pasrseAddress(results, status, options);
      });
    },
    pasrseAddress(result, status, options) {
      if (status === 'OK') {
        // 地址信息处理
        let results = result;
        results = results.sort(
          (x, y) => y.address_components.length - x.address_components.length,
        );
        if (results.length < 1) {
          return;
        }
        this.isMatch = this.setPinpointByResult(results[0], options);
        if (!this.isMatch && results.length > 1) {
          // 如果第一个结果定位不准，就用第二个结果
          this.isMatch = this.setPinpointByResult(results[1], options);
        }
      }
    },
    setPinpointByResult(useResult, options = {}) {
      this.marker?.setVisible(false);
      let { location } = useResult.geometry;
      // 想拖动marker定位，编辑地址定，如果有经纬度就用，不要拿geometry的经纬度，因为geometry返回的经纬度位数少，精确度低
      // 注意：latlng是经纬度对象。里面通过lat（）来拿定位
      if (options.latlng) {
        location = options.latlng;
      }
      if (options.rePostion === true) {
        this.marker?.setPosition(location);
      }
      this.marker?.setVisible(true);
      if (options.isCenter === true) {
        this.map.panTo(location);
      }
      // 截取详细地址
      const getAddressList = this.getAddressDetail(
        useResult.address_components,
      );
      const ary = [];
      getAddressList.forEach((item) => {
        if (item.res) {
          if (
            item.name === 'street_number' &&
            item.res.toLowerCase().indexOf('no.') < 0
          ) {
            ary.push(`NO.${item.res}`);
          } else {
            ary.push(item.res);
          }
        }
      });
      const temp = {};
      temp.ipLocation = location;
      temp.pacMsg = useResult.formatted_address;
      temp.lat = location.lat();
      temp.lng = location.lng();
      temp.addressDetail = ary.join(',');
      this.tempAddr = temp;
      this.tempAddr.saveParams = getSaveParam.call(this, useResult);
      // if (!this.tempAddr?.saveParams?.postalCode) {}
    },
    // 解析地址 国家 省 城市 区 路 邮编
    addressResult(result, detailName) {
      const res =
        (result.find((x) => (x.types || []).includes(detailName)) || {})
          .long_name || '';
      return res;
    },
    getAddressDetail(result) {
      const detailNameList = ['political', 'premise', 'street_number', 'route'];
      const getDetailNames = [];
      detailNameList.reverse().forEach((item) => {
        const res1 =
          (result.find((x) => (x.types || []).includes(item)) || {})
            .long_name || '';
        getDetailNames.push({ name: item, res: res1 });
      });
      return getDetailNames;
    },
    // 获取当前地址信息
    getCurrentAddress(cb) {
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          (pos) => {
            const location = {
              lat: pos.coords.latitude,
              lng: pos.coords.longitude,
            };
            if (!this.geocoder) return reject();
            this.geocoder?.geocode({ location }, (results, status) => {
              if (results?.length) {
                this.pasrseAddress(results, 'OK');
                resolve();
              } else {
                reject('==DEBUG==GOOGLE PINPOINT API ERROR');
              }
            });
          },
          (err) => {
            // default use jakarta address
            if (!this.geocoder) return reject();
            this.geocoder?.geocode(
              { location: jakartaLocation },
              (results, status) => {
                if (results?.length) {
                  this.pasrseAddress(results, 'OK');
                  resolve();
                } else {
                  reject('==DEBUG==GOOGLE PINPOINT API ERROR');
                }
              },
            );
            console.log(
              '==DEBUG==GET CURRENT POS ERROR You have denied location permission, or a network error has occurred',
            );
            this.err = {
              show: true,
              text: this.$t('googlemap.locationOutSide'),
              btnText: this.$t('googlemap.changeAddr'),
            };
          },
        );
      });
    },
    // 定位地图
    setPoint() {
      const { hasLocalAddr, localAddress } = this;
      if (hasLocalAddr) {
        const { latitude, longitude } = localAddress;
        const ipLocation = new window.google.maps.LatLng(latitude, longitude);
        this.getAddressByGeocoder(ipLocation, {
          rePostion: true,
          isCenter: true,
          latlng: ipLocation,
        });
      } else {
        curPos(jakartaLocation).then((location) => {
          const { lat, lng } = location;
          const ipLocation = new window.google.maps.LatLng(lat, lng);
          this.getAddressByGeocoder(ipLocation, {
            rePostion: true,
            isCenter: true,
            latlng: ipLocation,
          });
        });
      }
    },
    // 根据经纬度获取用户详细信息, 根据geocoder返回的结果拿到list，并处理 S
    // if (check || this.isCheckoutPage) {
    //           this.initAddress();
    //         }
    mapSourceListenerAndInit() {
      if (!window.google) {
        this.init();
        const script = document.querySelector('#map-source-ref');
        if (script) {
          script.onload = () => {
            if (this.isCheckoutPage) {
              this.initAddress();
            }
          };
        } else if (this.isCheckoutPage) {
          this.initAddress();
        }
      } else {
        this.init(true);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.checkDialog {
  border-radius: 10px !important;
  .q-btn {
    width: 220px;
    height: 40px;
  }
  .btn-default {
    border: 1px solid #d1d5db;
  }
  .mb {
    margin-bottom: 12px;
  }
}

.search-result-panel {
  background-color: #fff;
  width: 100%;
  min-height: 40px;
  padding: 16px;
  box-sizing: border-box;
  padding-top: 0;
  text-align: left;

  .search-result-container {
    border: 1px solid #dddddd;
    border-radius: 8px;
    padding: 12px 0;
  }
  .result-item-desc {
    height: 24px;
    line-height: 24px;
    padding: 0 12px;
    color: #545454;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 14px;
    margin-top: 0;
    margin-bottom: 8px;
    &:active {
      color: #ffdd00;
    }
  }
  .empty {
    color: #545454;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 14px;
    padding-left: 12px;
  }
  .result-item {
    &:last-child {
      .result-item-desc {
        margin-bottom: 0;
      }
    }
  }
}
.map-tiptop {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  align-items: center;
  height: 58px;
  background: #fff;
  text-align: center;
  padding: 0 10px;
  span {
    font-size: 20px;
    color: $headColor;
    margin-left: 15px;
    font-weight: 800;
  }
}
.address-history {
  strong {
    display: block;
    margin: 30px 0 0 5px;
  }
  ul {
    padding-inline-start: 0;
    li {
      list-style-type: none;
      font-size: 16px;
      color: $black;
      position: relative;
      padding: 0 0 0 30px;
      margin-bottom: 20px;
      &::after {
        display: block;
        width: 8px;
        height: 8px;
        content: ' ';
        font-size: 0;
        overflow: hidden;
        border: 2px solid #374151;
        border-radius: 50%;
        position: absolute;
        left: 10px;
        top: 50%;
        margin-top: -4px;
      }
      p {
        margin-bottom: 0;
      }

      span {
        display: inline-block;
        color: #374151;
        border-radius: 2px;
        padding: 0 5px;
        font-size: 12px;
        background: #f9fafb;
        border: 1px solid #d1d5db;
      }
    }
  }
}
.input-address {
  :deep(.q-field__bottom--animated) {
    bottom: none;
    top: -25px;
    transform: none;
    margin-right: -10px;
  }
  :deep(.q-field--with-bottom) {
    margin-top: 2px;
  }

  .label {
    font-weight: bold;
  }

  &.commentColor {
    :deep(.q-field__counter) {
      color: $primary;
    }
  }

  :deep(.q-textarea .q-field__control) {
    min-height: 42px;
    border-radius: 8px;
  }
  :deep(.q-textarea .q-field__native) {
    padding-top: 12px;
  }
  :deep(.q-textarea .q-field__native) {
    min-height: 42px;
  }
}

.choose-google-map {
  width: 100%;
  height: 100%;
  // overflow: hidden;
  align-items: center;
  background: #fff;
  padding-bottom: 120px;
}
.map-box-inner {
  width: 100%;
  padding: 10px;
  position: relative;
  // 警告框
  .notice-box {
    padding: 8px;
    background: #d1dff3;
    border-radius: 4px;
    box-sizing: border-box;
    margin: 20px 0px;
    color: $primary;
    display: flex;
    align-items: center;
    .icon {
      font-weight: bold;
      font-size: 18px;
      margin-right: 10px;
    }
    span {
      font-size: 12px;
      line-height: 16px;
    }
    &.error {
      color: $negative;
      background: #fef2f2;
      font-weight: 500;
    }
  }
  // 地图
  .map-search {
    // 搜索框
    .search-box {
      position: absolute;
      top: 20px;
      left: 0;
      right: 0;
      margin: 0 20px;
      box-sizing: border-box;
      input {
        width: 100%;
        height: 40px;
        background: #ffffff;
        border: 1px solid #d1d5db;
        border-radius: 8px;
        box-sizing: border-box;
        padding: 0 5px 0 45px;
        font-size: 16px;
        &:-ms-input-placeholder {
          color: #979898;
        }
        &:-moz-placeholder {
          color: #979898;
        }
        &::-moz-placeholder {
          color: #979898;
        }
        &::-webkit-input-placeholder {
          color: #979898;
        }
      }
    }
    .search-icon {
      position: absolute;
      top: 10px;
      height: 20px;
      left: 20px;
      width: 20px;
      color: #c4c4c4;
    }
    #map {
      width: 100%;
      height: 350px;
      border-radius: 10px;
      border: 1px solid #d1d5db;
      overflow: hidden;
    }
  }
  // 地址显示
  .address-box {
    margin: 15px 0;
    color: $black;
    font-size: 16px;
    line-height: 120%;
    margin-right: 15px;
    font-weight: bold;
    display: flex;
    align-items: center;
    .icon {
      width: 20px;
      height: 20px;
      margin-right: 10px;
      color: $black;
    }
    div {
      flex: 1;
    }
  }
  // 底部按钮
  .footer-box {
    background: #fff;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    box-sizing: border-box;
    padding: 10px 10px 20px 10px;

    :deep(.q-checkbox__label) {
      font-weight: bold;
      font-size: 16px;
    }

    // :deep(.q-checkbox__bg) {
    //   border: 1px solid #d1d5db;
    // }
    .footer-box-checkbox {
      margin-left: -15px;
    }
    .footer-button {
      width: 100%;
    }
  }
}
// 移动端搜索弹框 start
.search-box-mob {
  overflow: hidden !important;
  background: #ffffff;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  .search-header {
    width: 100%;
    // padding: 24px 64px;
    position: relative;
    text-align: center;
    button {
      position: absolute;
      right: 30px;
      top: 50%;
      margin-top: -16px;
    }
  }
  .closeBtn {
    position: absolute;
    left: 10px;
    top: 13px;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    i {
      font-size: 24px;
    }
  }
}
.seach-mob {
  flex: 1;
  padding: 16px;
  box-sizing: border-box;
  position: relative;
  width: 100%;
  input {
    width: 100%;
    height: 40px;
    font-size: 16px;
    background: #ffffff;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    box-sizing: border-box;
    padding: 0 5px;
    text-indent: 40px;
    color: $black;
    // -webkit-text-fill-color: #4a71d3;
    &:-ms-input-placeholder {
      color: #979898;
    }
    &:-moz-placeholder {
      color: #979898;
    }
    &::-moz-placeholder {
      color: #979898;
    }
    &::-webkit-input-placeholder {
      color: #979898;
    }
  }
  .search-icon {
    position: absolute;
    left: 30px;
    top: 16px;
    height: 40px;
    width: 22px;
  }
  .currentLocation {
    display: flex;
    align-items: center;
    // padding: 20px 16px;
    box-sizing: border-box;
    // svg {
    //   margin-right: 10px;
    // }
  }
  .seach-mob-input:focus {
    outline: none;
  }
}
.search-input-mob {
  display: none;
}
@media screen and (max-width: 960px) {
  .choose-google-map {
    max-width: unset !important;
    max-height: unset !important;
  }
  .search-input-mob {
    display: block;
  }
  .search-input-pc {
    display: none;
  }
  .map-box-inner .footer-box .btn {
    min-width: 100%;
  }
  .map-box-inner .footer-box .btn.btn-cancel {
    display: none;
  }
}

// 移动端搜索 end
</style>
<style lang="scss">
// google 地图中makr标记顶部的文案信息设置最大宽度
.gm-ui-hover-effect {
  display: none !important;
}
.gm-style-iw-d {
  div {
    color: $primary;
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 120%;
    max-width: 180px;
    overflow: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin: 0 auto;
  }
}
/* google搜索列表被遮挡 */
.pac-container {
  z-index: 9999 !important;
  // q-dialog会导致body设置top，如果此处absolute定位，谷歌取的是input输入框相对应浏览器视图窗口的位置，导致定为不准
  position: fixed !important;
  box-shadow: none !important;
}
// 搜索列表的图标
.pac-icon {
  background-image: url('~assets/icons/svg/icon/googlemap-pos.svg') !important;
  background-position: center !important;
  background-repeat: no-repeat;
  width: 20px !important;
  height: 18px !important;
  background-size: contain;
  padding-right: 10px;
}
// .pac-item-selected {
//   .pac-icon {
//     background-image: url('~assets/icons/svg/icon/position.svg') !important;
//     background-size: contain;
//   }
// }
// 搜索结果列表，干掉google标记
.pac-logo:after {
  background-image: none !important;
  height: 0 !important;
}
@media screen and (max-width: 960px) {
  // mobile端，自定义搜索列表list的显示样式
  .pac-container {
    z-index: 9999 !important;
    margin: 0 -16px;
    width: 100% !important;
    height: calc(100% - 180px);
    overflow: auto;
    border: none;
    .pac-item {
      padding: 16px 20px 16px 36px;
      font-size: 16px;
      line-height: 16px;
      color: #374151;
      display: flex;
      flex-direction: column;
      position: relative;
      white-space: normal;
      border: none;
      .pac-icon {
        position: absolute;
        display: block;
        width: 16px;
        height: 16px;
        top: 50%;
        margin-top: -7px;
        left: 16px;
      }
      span:nth-child(3) {
        margin-left: 10px !important;
        padding-right: 12px !important;
      }
      span {
        width: 100%;
        box-sizing: border-box;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        border: none;
        &.pac-item-query {
          display: inline !important;
          font-size: 16px;
          padding-left: 10px;
        }
        &.pac-matched {
          display: inline !important;
          font-size: 16px;
        }
      }
    }
  }
  .google-map-special {
    .q-dialog__inner--minimized {
      padding: 0 !important;
      box-shadow: none !important;
    }
  }
  // .q-dialog__inner > div {
  //   border-radius: 0 !important;
  //   box-shadow: none !important;
  // }
}
.pac-matched {
  color: #ff9e2d;
}
.address-address {
  .q-field--outlined .q-field__control:before {
    border-color: #d1d5db;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
  }
  .q-field__control {
    height: 42px;
    min-height: unset;
  }
  .inputBox {
    height: 42px;
    padding-bottom: 0;
    margin-top: 8px;
  }
  .q-field__bottom--animated {
    bottom: 72px !important;
    color: #6b7280;
    font-size: 12px;
  }
  .q-field__counter {
    font-size: 12px;
  }
  .label {
    font-weight: bold;
    color: $black;
    font-size: 12px;
    line-height: 120%;
    margin-bottom: 6px;
  }
}
</style>
